import { useNavigate } from 'react-router-dom';
import { Medico, Status } from '../../data/types/medico.types';
import { medicoConstants } from '../../data/types/medicos.types';
import { useMedicos } from '../../data/hooks/useMedicos.hook';
import SmartGrid, { ColumnConfig } from '../../components/smartGrid/SmartGrid';
import { getStringOfEspecialidades } from '../../helpers/especialidades.helper';
import { useEspecialidades } from '../../data/hooks/useEspecialidades.hook';
import { EntityConstants } from '../../helpers/general.helper';
import { Spinner } from '../../components/spinner/Spinner.component';
 


const formatStatus = (value: string) => {
	if (value === Status.PENDIENTE) return <span style={{color: '#cfae1d', fontWeight: 'bold'}}>Pendiente</span>
	if (value === Status.RECHAZADO) return <span style={{color: '#bd1c11', fontWeight: 'bold'}}>Rechazado</span>
	if (value === Status.APROBADO) return <span>Aprobado</span>
}
 
interface Entity extends Medico {}
const entityConstants: EntityConstants = {
	...medicoConstants,
	navigateToParent: '/med/admin/medicos'
}
 
export const MedicosBrowse = () => {
	const {data, isPending, isError, error } = useMedicos()
	const {data: especialidadesData, isPending: especPending, isError: especIsError, error: especError } = useEspecialidades()
 
	const navigate = useNavigate()
 
	const formatEspecialidades = (value: string) => {
		console.log("### value", value)
		console.log("### especialidadesData", especialidadesData)
		return getStringOfEspecialidades(value, especialidadesData || [])
	}
	 
	const columns: ColumnConfig[] = [
		{
		  key: 'nombre',
		  header: 'Nombre',
		  dataType: 'text',
		  filterable: true,
		  sortable: true,
		  horizontalAlign: 'left',
		  width: 30
		},
		{
		  key: 'apellido',
		  header: 'Apellido',
		  dataType: 'text',
		  filterable: true,
		  sortable: true,
		  horizontalAlign: 'left',
		  width: 30
		},
		{
		  key: 'especialidades',
		  header: 'Especialidades',
		  dataType: 'text',
		  filterable: true,
		  filterBy: 'FORMATTED',
		  sortable: true,
		  horizontalAlign: 'left',
		  width: 30,
		  formatter: formatEspecialidades
		},
		{
		  key: 'status',
		  header: 'Status',
		  dataType: 'text',
		  filterable: true,
		//   filterDefault: 'Pendiente',
			filterOptions: [
				{ value: Status.PENDIENTE, label: 'Pendiente' },
				{ value: Status.APROBADO, label: 'Aprobado' },
				{ value: Status.RECHAZADO, label: 'Rechazado' },
			],
			sortable: true,
			horizontalAlign: 'left',
			width: 30,
			formatter: formatStatus
		},
	];
   
	const rowActions = [
		{
		  label: '',
		  action: (selected: Entity[]) => navigate(`${entityConstants.navigateToParent}/${selected[0].dni}`),
		  icon: '✏️'
		},
	]
 
	if (isPending) return <Spinner />
	
	return (
		<div style={{ margin: '0 150px' }}>
			{isError && <div style={{ color: 'red' }}>Error: {error?.message}</div>}
			{(!isPending && !isError) && <SmartGrid
				data={data || []}
				columns={columns}
				pageSize={10}
				rowActions={rowActions}
				defaultSort={{ key: 'nombre', direction: 'desc' }}
				toolbarComponents={[
				  {
					type: 'title',
					title: entityConstants.entityLabel,
					count: true,
				  },
				//   {
				//     type: 'command',
				//     label: `${entityConstants.entityLabelGender === 'F' ? 'Nueva' : 'Nuevo'} ${entityConstants.entityLabel}`,
				//     onClick: () => navigate(`${entityConstants.navigateToParent}/new`),
				//   }
				]}
			/>}
		</div>
	);
 
}